import {httpGet} from './http';

const accessoryUrl = window.env.BACKEND_API_URL + '/accessories';

const getAccessories = async (page, pageSize, signal) => {
    const accessoriesIndexUrl = `${accessoryUrl}?page=${page}&per_page=${pageSize}`;

    return await httpGet(accessoriesIndexUrl, signal);
};

export {getAccessories};